<template>
    <v-app>
        <v-main>
            <v-row class="fill-height">
                <v-col
                    cols="12"
                    class="pa-0"
                    style="position: relative">
                    <v-tabs
                        v-if="!removePartials"
                        grow
                        color="primary">
                        <v-tab to="login">
                            Login
                        </v-tab>
                        <v-tab to="signup">
                            Sign up
                        </v-tab>
                    </v-tabs>

                    <router-view />

                    <div
                        v-if="$store.state.progressbar"
                        class="d-flex justify-center align-center progress-overlay">
                        <v-progress-circular
                            size="72"
                            color="white"
                            indeterminate />
                    </div>
                </v-col>
            </v-row>
        </v-main>

        <app-footer />

        <v-snackbar
            v-model="snackbar.isOpened"
            :timeout="snackbar.closable ? -1 : 5000"
            bottom
            :color="snackbar.color">
            {{ snackbar.text }}

            <span
                v-if="snackbar.subtext"
                class="d-block text-small text-center">
                {{ snackbar.subtext }}
            </span>

            <v-btn
                v-if="snackbar.closable"
                slot="action"
                icon
                @click="closeSnackbar">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>
import AppFooter from '@/components/App/AppFooter';

export default {
    name: 'Default',

    components: { AppFooter },

    computed: {
        snackbar() {
            return this.$store.state.snackbar;
        },
        removePartials() {
            return this.$route.meta.removePartials;
        },
    },

    created() {
        setTimeout(() => {
            this.$store.commit('setReferrer', this.$route.query.referrer);
        }, 500);
    },

    methods: {
        closeSnackbar() {
            this.$store.commit('closeSnackbar');
        },
    },
};
</script>

<style lang="scss">
.progress-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
